// extracted by mini-css-extract-plugin
export var core = "Dimas-module--core--35cc7";
export var img = "Dimas-module--img--19630";